<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="db-title">
          Das ging <span class="db-title-green">schnell</span>, oder?
        </div>
        <div class="db-textblock">
          Dank Ihrer Angaben konnten wir Ihnen die günstigsten Artikel
          zusammenstellen – ganz individuell für Ihr Projekt! Nun fehlen nur
          noch Ihre Kontaktdaten und wir können Ihre Angebotsanfrage aufnehmen.
          Lassen Sie uns keine Zeit verlieren!
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-8">
        <div class="table result-table">
          <div class="table-header">
            <div class="table-cell">
              Artikel
            </div>
            <div class="table-cell">
              Menge
            </div>
            <div class="table-cell">
              &nbsp;
            </div>
            <div class="table-cell">
              Preis
            </div>
          </div>
          <div
            class="table-row"
            v-for="(product, r) in products"
            v-bind:key="r"
          >
            <div class="table-cell cell-productname" v-if="product.url">
              <a :href="product.url" target="_blank">{{ product.name }}</a>
            </div>
            <div class="table-cell cell-productname" v-else>
              {{ product.name }}
            </div>
            <div class="table-cell cell-qty">
              {{ product.qty }}
            </div>
            <div class="table-cell cell-qty">
              <span class="unit">{{ product.unit }}</span>
            </div>
            <div class="table-cell cell-price product-price">
              {{ formatPrice(getProductPriceSum(product.price, product.qty)) }}
            </div>
          </div>
        </div>
        <div class="totalRow">
          <span>Netto {{ formatPrice(totalNet) }}</span>
        </div>
        <div class="totalRow">
          <span>Mwst. {{ formatPrice(totalTax) }}</span>
        </div>
        <div class="totalRow totalGross">
          <span
            ><strong>Gesamt Brutto:</strong> {{ formatPrice(totalGross) }}</span
          >
        </div>
        <div class="totalRow"><small>zzgl. Versandkosten</small></div>
      </div>
      <div class="col-md-4 d-none d-md-block">
        <div
          class="db-image-frame"
          style="transform: rotate(2deg); margin-top: 30px;"
        >
          <img src="../assets/room1.jpg" />
        </div>
      </div>
      <div class="col-12 sv_nav">
        <button @click="prevPage()" class="sv_prev_btn">Zurück</button>
        <button @click="nextPage()" class="db-btn">Jetzt anfragen</button>
      </div>
    </div>
    <div>
      <db-debug-product-list v-if="debug === true"></db-debug-product-list>
    </div>
  </div>
</template>
<script>
import productset from "../product_sets.json";

export default {
  data() {
    return {
      productset: productset,
      debug: false,
    };
  },

  computed: {
    results: function () {
      return this.$store.state.results;
    },

    products: function () {
      return this.$store.state.products;
    },

    totalGross() {
      let totalGross = 0;

      this.products.forEach(function (product) {
        totalGross += product.price * product.qty;
      });

      return Math.ceil(totalGross * 100) / 100;
    },

    totalNet() {
      return Math.round((this.totalGross / 1.19) * 100) / 100;
    },

    totalTax() {
      return Math.round((this.totalGross - this.totalNet) * 100) / 100;
    },

    areaQcm() {
      return this.results.ask_height * this.results.ask_width;
    },

    areaQm() {
      return (this.results.ask_height * this.results.ask_width) / 10000;
    },
  },

  created() {
    if (this.$store.state.results === null) {
      this.$store.commit("setResults", {
        ask_width: 0,
        ask_height: 0,
        ask_thickness: 50,
        ask_planking: 1,
        ask_door: 1,
        daemmstoff: "glaswolle",
        coveringplates: "gipsfaserplatten",
      });
    }

    this.setDefaults();
    this.updateProducts();
  },

  mounted() {
    window.hj("vpv", "/produktliste");
    console.log("hj /produktliste");
  },

  methods: {
    updateProducts() {
      this.$store.commit(
        "setProducts",
        [
          this.getSealingTape(),
          this.getCWProfiles(),
          this.getUWProfiles(),
          this.getPartitionPlate(),
          this.getPlasterBoard(),
          this.getNailDowels(),
          this.getScrews(),
          this.getScrewsSecondLayer(),
          this.getJointFiller(),
          this.getAcryl(),
          this.getDoorAngleSets(),
          this.getUaProfiles(),
          this.getLintelProfiles(),
        ].filter((x) => !!x)
      );
      console.log("Products updated!");
    },

    nextPage() {
      this.$store.commit("setActivePage", "customerForm");
    },

    prevPage() {
      this.$store.commit("setActivePage", "questionaire");
    },

    getSealingTape() {
      let self = this;
      let product = this.productset.sealingTapes.filter(function (el) {
        return el.attributes.for_thickness == self.results.ask_thickness;
      })[0];

      product.qty = Math.ceil(
        (parseInt(this.results.ask_width) * 2) / parseInt(product.content)
      );

      return product;
    },

    getCWProfiles() {
      let self = this;
      let product = this.productset.cwProfiles.filter(function (el) {
        if (self.results.ask_height <= 260) {
          return (
            el.attributes.for_thickness == self.results.ask_thickness &&
            el.content == 260
          );
        }
        return (
          el.attributes.for_thickness == self.results.ask_thickness &&
          el.content == 400
        );
      })[0];

      product.qty = Math.ceil(parseInt(this.results.ask_width) / 62.5) + 1;

      product.qty = Math.ceil(
        product.qty / Math.floor(product.content / this.results.ask_height)
      );

      return product;
    },

    getUWProfiles() {
      let self = this;
      let product = this.productset.uwProfiles.filter(function (el) {
        return el.attributes.for_thickness == self.results.ask_thickness;
      })[0];

      product.qty = Math.ceil(
        (parseInt(this.results.ask_width) * 2) / product.content
      );

      return product;
    },

    getPartitionPlate() {
      let self = this;
      let product = this.productset.partitionPlates.filter(function (el) {
        return (
          el.attributes.for_thickness == self.results.ask_thickness &&
          el.attributes.material == self.results.daemmstoff
        );
      })[0];

      product.qty = Math.ceil(this.areaQcm / product.content);
      return product;
    },

    getPlasterBoard() {
      //let product = this.productset.plasterBoards[0];
      let self = this;
      let product = this.productset.plasterBoards.filter(function (el) {
        return el.attributes.material == self.results.coveringplates;
      })[0];

      let multiplicator = this.results.ask_planking == "2" ? 4 : 2;

      product.qty = Math.ceil((this.areaQcm * multiplicator) / product.content);

      return product;
    },

    getScrews() {
      let product = this.productset.screws[0];

      if (this.results.ask_planking == "2") {
        product.qty = Math.ceil((this.areaQm * 14) / product.content);
      } else {
        product.qty = Math.ceil((this.areaQm * 30) / product.content);
      }

      return product;
    },

    getScrewsSecondLayer() {
      let product = this.productset.screwsSecondLayer[0];

      if (this.results.ask_planking == "2") {
        product.qty = Math.ceil((this.areaQm * 30) / product.content);
      } else {
        return null;
      }

      return product;
    },

    getJointFiller() {
      let product = this.productset.jointFiller[0];

      if (this.results.ask_planking == "2") {
        product.qty = Math.ceil(this.areaQm / (product.content / 0.8));
      } else {
        product.qty = Math.ceil(this.areaQm / (product.content / 0.5));
      }

      return product;
    },

    getNailDowels() {
      let product = this.productset.nailDowels[0];

      product.qty = Math.ceil(Math.ceil(this.areaQm * 1.6) / product.content);

      return product;
    },

    getAcryl() {
      let product = this.productset.acryl[0];

      let estimatedJointSizePerTube = 800; // cm

      product.qty = Math.ceil(
        (this.results.ask_height * 4) / estimatedJointSizePerTube
      );

      return product;
    },

    getDoorAngleSets() {
      let self = this;
      let product = this.productset.doorAngle.filter(function (el) {
        return el.attributes.for_thickness == self.results.ask_thickness;
      })[0];

      if (self.results.ask_door < 1 || self.results.ask_door == undefined) {
        return null;
      }

      product.qty = self.results.ask_door;

      return product;
    },

    getUaProfiles() {
      let self = this;
      let product = this.productset.uaProfiles.filter(function (el) {
        if (self.results.ask_height <= 260) {
          return (
            el.attributes.for_thickness == self.results.ask_thickness &&
            el.content == 260
          );
        }
        return (
          el.attributes.for_thickness == self.results.ask_thickness &&
          el.content == 400
        );
      })[0];

      if (self.results.ask_door < 1 || self.results.ask_door == undefined) {
        return null;
      }

      product.qty = Math.ceil(parseInt(this.results.ask_door) * 2);

      return product;
    },

    getLintelProfiles() {
      let self = this;
      let product = this.productset.lintelProfiles.filter(function (el) {
        return el.attributes.for_thickness == self.results.ask_thickness;
      })[0];

      if (self.results.ask_door < 1 || self.results.ask_door == undefined) {
        return null;
      }

      product.qty = self.results.ask_door;

      return product;
    },

    setDefaults() {
      if (
        !this.results.ask_thickness ||
        this.results.ask_thickness === "undefined"
      ) {
        this.results.ask_thickness = 75;
      }
    },

    addProduct(id, sku, name, desc, qty) {
      let p = this.products.filter(function (el) {
        return el.sku === sku;
      });

      if (p.length > 0) {
        p[0].qty += qty;
      } else {
        this.products.push({
          id: id,
          sku: sku,
          name: name,
          desc: desc,
          qty: qty,
        });
      }
    },

    getProductPriceSum(price, qty, prefix = "", suffix = "") {
      let sum = prefix + Math.ceil(price * qty * 100) / 100 + suffix;
      return sum;
    },

    formatPrice(price) {
      return new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "EUR",
      }).format(price);
    },

    getTotalNet() {
      let totalNet = 0;
      totalNet;
    },
  },
};
</script>

<style scoped>
/*
.table {
  display: table;
}
.table-row {
  display: table-row;
}
.table-cell {
  display: table-cell;
  padding: 5px;
}
.table-header {
  display: table-header-group;
  font-weight: bold;
  font-size: 1rem;
  background-color: #595d5e;
  color: #fff;
}

.unit {
  color: grey;
}

.result-table {
  margin-top: 40px;
  margin-bottom: 10px;
}

.product-price {
  text-align: right;
  white-space: nowrap;
}

.totalRow {
  text-align: right;
  padding-right: 5px;
  padding-top: 10px;
}

.totalGross span {
  border-bottom: 3px double #000;
}

.result-table a {
  color: #000;
}
*/
</style>
